type Truthy<T> = T extends '' | 0 | false | null | undefined ? never : T;

export const isTruthy = <T>(value: T): value is Truthy<T> => !!value;

export const truncate = (
  str: string,
  maxLength: number = 80,
  suffix = '...',
) => {
  if (str.length <= maxLength) {
    return str;
  }

  return str.substring(0, maxLength) + suffix;
};
